// @flow

require('file?name=favicon.ico!./static/favicon.ico');
require('file?name=robots.txt!./static/robots.txt');
require('./static/manifest.json');

// Uncomment for React Performance Tools @see https://facebook.github.io/react/docs/perf.html
// require('perf');

import { environment, version, raygunIsEnabled, raygunApiKey, metricsPrefix, metricsHost, metricsIsEnabled } from 'config';
import { serializeUnsentImpressions, forceTrackingRequest } from 'job-tracking';

// Polyfill ES2015 promises
import Promise from 'bluebird';
window.Promise = window.Promise || Promise;

if (raygunIsEnabled) {
  /* global Raygun */
  require('raygun4js');
  Raygun
    .init(raygunApiKey, {
      ignoreAjaxAbort: true
    })
    .setVersion(version)
    .attach()
    .withTags([
      `environment:${environment}`,
      'client'
    ]);
}

import ariaClick from 'aria-click';
ariaClick(document);

import metrics from 'metrics';
import clientMetrics from 'metrics/client';
import pathnameToPageName from './pathnameToPageName';
import browser from 'detect-browser';

metrics.use(clientMetrics({
  host: metricsHost,
  isEnabled: metricsIsEnabled,
  prefix: metricsPrefix,
  globalTags: [
    `version:${version}`,
    `environment:${environment}`,
    `browser-name:${browser.name}`,
    `browser-version:${browser.version}`
  ]
}));
metrics.sendPagePerformance([`houston-page:${pathnameToPageName(window.location.pathname)}`]);

// Flush pending job tracking impressions
forceTrackingRequest();

// Serialize unsent tracking events before we leave the page.
window.addEventListener('beforeunload', () => {
  serializeUnsentImpressions();
});

import clientRender from './client-render';
clientRender(document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./app/client.js
 **/